/**
 * Chunk / job ledger table for a bulk RMA action request.
 */
import { FONT_COLOR } from '../../../../../../components/fonts/font-props';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import Table from '../../../../../../components/table/table';
import { IColumn } from '../../../../../../components/table/table.types';
import { IBulkRmaActionJob } from '../../../../../../services/api/troubleshooting-service';
import ChunkLedgerTableRow from './chunk-ledger-table-row';

interface IChunkLedgerTableProps {
    jobs: IBulkRmaActionJob[];
}

const JOBS_COLUMNS: IColumn[] = [
    { content: 'ID', width: { value: 72, type: 'px' } },
    { content: 'Status', width: { value: 110, type: 'px' } },
    { content: 'Returns', width: { value: 72, type: 'px' } },
    { content: 'Queued', width: { value: 140, type: 'px' } },
    { content: 'Started', width: { value: 140, type: 'px' } },
    { content: 'Finished', width: { value: 140, type: 'px' } },
    { content: 'Failure', width: { value: 2, type: 'fr' } },
];

const ChunkLedgerTable: React.FC<IChunkLedgerTableProps> = ({ jobs }) => (
    <div className="bulk-rma-actions-page__detail-section">
        <h5>Chunk ledger</h5>
        <p className="bulk-rma-actions-page__hint">
            Chunks are queued in order. A processing request with unresolved returns and no queued or running chunk is stuck.
        </p>
        {jobs.length === 0 ? (
            <FontBody2 color={FONT_COLOR.PRIMARY2}>No chunks recorded yet.</FontBody2>
        ) : (
            <div className="bulk-rma-actions-page__table-wrapper">
                <Table columns={JOBS_COLUMNS}>
                    {jobs.map((job) => (
                        <ChunkLedgerTableRow key={job.id} job={job} />
                    ))}
                </Table>
            </div>
        )}
    </div>
);

export default ChunkLedgerTable;
